import React from "react"
import ReactDOM from "react-dom/client"

// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)

root.render(
  // <GoogleReCaptchaProvider
  //   reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY as string}
  // >
      <App />
  // </GoogleReCaptchaProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
